/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerGetFileContentQueryResponse, ArtifactsControllerGetFileContentPathParams, ArtifactsControllerGetFileContent404 } from "../../models/documentArtifactsController/ArtifactsControllerGetFileContent";

function getArtifactsControllerGetFileContentUrl(documentId: ArtifactsControllerGetFileContentPathParams["documentId"], renditionId: ArtifactsControllerGetFileContentPathParams["renditionId"], artifactId: ArtifactsControllerGetFileContentPathParams["artifactId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${documentId}/renditions/${renditionId}/artifacts/${artifactId}/content` as const }  
  return res
}

/**
 * @description Retrieves the actual file content of an artifact from storage
 * @summary Get artifact file content
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/content}
 */
export async function artifactsControllerGetFileContent(documentId: ArtifactsControllerGetFileContentPathParams["documentId"], renditionId: ArtifactsControllerGetFileContentPathParams["renditionId"], artifactId: ArtifactsControllerGetFileContentPathParams["artifactId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ArtifactsControllerGetFileContentQueryResponse, ResponseErrorConfig<ArtifactsControllerGetFileContent404>, unknown>({ method : "GET", url : getArtifactsControllerGetFileContentUrl(documentId, renditionId, artifactId).url.toString(), ... requestConfig })  
  return res.data
}